/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { TeamsInTenant } from "@microsoft/shifts-models-data";
// TODO: Replace 'sh-services' dependency from Web core with one from a workspace package.
import { NetworkService } from "sh-services";
import { DataProvider } from "sh-services/dataproviders/DataProvider";

import { TeamsInTenantDataProviderParams } from "./TeamsInTenantDataProviderParams";

/**
 * The teams in tenant data provider.
 */
export class TeamsInTenantDataProvider extends DataProvider<TeamsInTenant> {
    /**
     * Instantiates a new instance of the TeamsInTenant.
     * @param params The parameters.
     */
    constructor(private readonly params: TeamsInTenantDataProviderParams) {
        super();
    }

    /**
     * Not supported.
     */
    public async getDataFromMemory(): Promise<TeamsInTenant | undefined> {
        // Memory only stores view models, so returning undefined.
        return undefined;
    }

    /**
     * Not supported.
     */
    public async getDataFromDatabase(): Promise<TeamsInTenant | undefined> {
        // Not using persistent cache, so returning undefined.
        return undefined;
    }

    /**
     * Gets data from network call.
     * @returns The data from the network call.
     */
    public async getDataFromNetwork(): Promise<TeamsInTenant> {
        const url = `/api/crosslocationteams`;
        const urlSignature = "/api/crosslocationteams";

        const { data: { teams } } = await NetworkService.sendHttpRequestToStaffHubService<{
            /**
             * The teams in the tenant.
             */
        teams: TeamsInTenant}>({
            method: "GET",
            url,
            urlSignature
        });

        return teams;
    }

    /**
     * Sets data in memory.
     * @param data The data to set in memory.
     */
    public async setDataInMemory(data: TeamsInTenant): Promise<void> {
        this.params.setDataInMemory(data);
    }

    /**
     * Not supported.
     */
    public async setDataInDatabase(): Promise<void> {
        return undefined;
    }

    /**
     * Not supported.
     */
    public async saveDataToNetwork(): Promise<TeamsInTenant | undefined> {
        return undefined;
    }
}
